import {
  takeLatest, call, put
} from 'redux-saga/effects';
import {
  LOAD_PARTS_REQUEST,
  LOAD_PARTS_SUCCESS,
  LOAD_PARTS_ERROR
} from '../actions/index';

import $dataRepo from 'dataRepository';

// watcher saga: watches for actions dispatched to the store, starts worker saga
export default function* rootSaga() {
  yield takeLatest(LOAD_PARTS_REQUEST, fetchParts);
}

// worker sagas: makes the api call when watcher saga sees the action
function* fetchParts() {
  try {
    const loadedParts = yield call($dataRepo.fetchPartsData);
    const loadedConnections = {
      accessories: {}
    };

    // success, store the content
    yield put({ type: LOAD_PARTS_SUCCESS, loadedParts, loadedConnections });
  } catch (error) {
    // error, reset content
    yield put({ type: LOAD_PARTS_ERROR, error });
  }
}
